import React from 'react';
import { Box, Card, CardContent, Typography, Button } from '@mui/material';

const Payments = () => {
  return (
    <Box sx={{ pt: { xs: 7, md: 3 }}}>
      <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 700 }}>
        My Payments
      </Typography>
      <Card>
        <CardContent>
          <Typography variant="body1" color="text.secondary" gutterBottom>
            Payment methods and billing history will appear here.
          </Typography>
          <Button variant="contained" disabled>
            Add Payment Method
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Payments;


